import React from "react";
import { Button } from "antd";

import { useNavigate } from "react-router-dom";
import { AuthContextValue, useAuth } from "../providers/AuthProvider";

function InactiveUserPage() {
  const navigate = useNavigate();
  const { logout: signOut } = useAuth() as AuthContextValue;

  const _signOut = () => {
    const token = localStorage.getItem("token");

    if (token) {
      signOut();
    }
  };
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        paddingTop: 100,
      }}
    >
      <div
        style={{
          width: "30%",
          alignSelf: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: 250,
          fontFamily: "Poppins",
          padding: 20,
          borderRadius: 8.5,
          paddingLeft: 50,
          paddingRight: 50,
          paddingTop: 22,
          backgroundColor: "white",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
            gap: 12,
          }}
        >
          <div style={{ fontFamily: "Poppins", fontSize: 50 }}>403</div>
          <div style={{ fontFamily: "Poppins", fontSize: 22 }}>
            Access denied
          </div>
          <div style={{ textAlign: "center" }}>
            You account has not been activated yet. Please contact the system
            administrator.
          </div>
          <Button onClick={_signOut} type="primary">
            Sign out
          </Button>
        </div>
      </div>
    </div>
  );
}

export default InactiveUserPage;
